import { Box, Skeleton } from '@redbubble/design-system';
import styles from './Topic.module.scss';

export const TopicLoading: React.FC = () => {
  return (
    <Box className={styles.skeletonPill}>
      <Skeleton animated width={130} height={34} data-testid="topic-skeleton" />
    </Box>
  );
};
